import '@testing-library/jest-dom';
import { fireEvent, render, screen } from '@testing-library/react';

import { FeedbackBar } from './FeedbackBar';

describe('FeedbackBar', () => {
  it('should render with children text', () => {
    render(<FeedbackBar>My feedback message</FeedbackBar>);
    expect(screen.getByText('My feedback message')).toBeInTheDocument();
  });

  it('should close when the close button is clicked', () => {
    render(<FeedbackBar>My closed feedback message</FeedbackBar>);

    expect(screen.getByRole('alert')).toHaveClass('feedback-bar--visible');

    const closeButton = screen.getByRole('button');
    fireEvent.click(closeButton);

    expect(screen.getByRole('alert')).not.toHaveClass('feedback-bar--visible');
  });
});
